(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oakverly-product-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialiseProduct = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const select = root.querySelector('[data-variant-select]');
    const gallery = root.querySelector('[data-gallery]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const indexByImageId = new Map();
    let showGallerySlide = null;
    const getImageIndex = (imageId) => indexByImageId.get(String(imageId || ''));

    if (gallery) {
      const slider = gallery.querySelector('[data-gallery-slider]');
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      const rail = gallery.querySelector('.ovp-product__thumbnails');
      const previous = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      const counter = gallery.querySelector('[data-gallery-counter]');
      let activeIndex = 0;
      let touchStart = null;

      slides.forEach((slide, index) => {
        if (slide.dataset.imageId) indexByImageId.set(String(slide.dataset.imageId), index);
      });

      const showSlide = (requestedIndex) => {
        if (!track || slides.length === 0 || !Number.isInteger(requestedIndex)) return;
        activeIndex = ((requestedIndex % slides.length) + slides.length) % slides.length;
        track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
        slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== activeIndex)));
        const activeImage = slides[activeIndex].querySelector('img');
        if (activeImage) activeImage.loading = 'eager';
        thumbs.forEach((thumb, index) => {
          thumb.classList.toggle('is-active', index === activeIndex);
          thumb.setAttribute('aria-pressed', String(index === activeIndex));
        });
        const activeThumb = thumbs[activeIndex];
        if (rail && activeThumb) {
          const target = rail.scrollLeft + activeThumb.getBoundingClientRect().left - rail.getBoundingClientRect().left - (rail.clientWidth - activeThumb.clientWidth) / 2;
          rail.scrollTo({left:Math.max(0, Math.min(target, rail.scrollWidth - rail.clientWidth)), behavior:reducedMotion ? 'auto' : 'smooth'});
        }
        if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      };

      showGallerySlide = showSlide;
      previous?.addEventListener('click', () => showSlide(activeIndex - 1));
      next?.addEventListener('click', () => showSlide(activeIndex + 1));
      thumbs.forEach(thumb => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.index))));
      slider?.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        showSlide(activeIndex + (event.key === 'ArrowLeft' ? -1 : 1));
      });
      slider?.addEventListener('touchstart', event => {
        const touch = event.changedTouches[0];
        touchStart = touch ? {x:touch.clientX, y:touch.clientY} : null;
      }, {passive:true});
      slider?.addEventListener('touchend', event => {
        const touch = event.changedTouches[0];
        if (!touchStart || !touch) return;
        const dx = touch.clientX - touchStart.x;
        const dy = touch.clientY - touchStart.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) showSlide(activeIndex + (dx < 0 ? 1 : -1));
        touchStart = null;
      }, {passive:true});
      slider?.addEventListener('touchcancel', () => { touchStart = null; }, {passive:true});

      const initialImageId = select?.selectedOptions[0]?.dataset.imageId || root.dataset.initialImageId;
      showSlide(getImageIndex(initialImageId) ?? 0);
    }

    if (!select) return;
    const price = root.querySelector('[data-product-price]');
    const comparePrice = root.querySelector('[data-compare-price]');
    const availability = root.querySelector('[data-availability]');
    const availabilityText = root.querySelector('[data-availability-text]');
    const addButton = root.querySelector('[data-add-button]');
    const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
    const skuWrap = root.querySelector('[data-sku-wrap]');
    const sku = root.querySelector('[data-sku-wrap] [data-sku]');
    const quantity = root.querySelector('[data-quantity-input]');

    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      const compare = option.dataset.compare || '';
      if (price) price.textContent = option.dataset.price || '';
      if (comparePrice) {
        comparePrice.textContent = compare;
        comparePrice.hidden = compare === '';
      }
      availability?.classList.toggle('ovp-product__availability--unavailable', !available);
      if (availabilityText) availabilityText.textContent = available ? 'Available to order' : 'Currently unavailable';
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? root.dataset.addText : root.dataset.soldoutText;
      }
      if (dynamicCheckout) dynamicCheckout.hidden = !available;
      if (skuWrap && sku) {
        sku.textContent = option.dataset.sku || '';
        skuWrap.hidden = !option.dataset.sku;
      }
      if (quantity) {
        const minimum = Number.parseInt(option.dataset.quantityMin,10) || 1;
        const step = Number.parseInt(option.dataset.quantityStep,10) || 1;
        const maximum = Number.parseInt(option.dataset.quantityMax,10);
        quantity.min = String(minimum);
        quantity.step = String(step);
        if (Number.isFinite(maximum)) quantity.max = String(maximum);
        else quantity.removeAttribute('max');
        let value = quantity.type === 'hidden' ? minimum : Math.max(minimum, Number.parseInt(quantity.value,10) || minimum);
        value = minimum + Math.ceil((value - minimum) / step) * step;
        if (Number.isFinite(maximum) && value > maximum) value = minimum + Math.floor((maximum - minimum) / step) * step;
        quantity.value = String(Math.max(minimum, value));
      }
      const imageIndex = getImageIndex(option.dataset.imageId);
      if (showGallerySlide && Number.isInteger(imageIndex)) showGallerySlide(imageIndex);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState(window.history.state, '', url.toString());
      root.dispatchEvent(new CustomEvent('oakverly:variant-change', {bubbles:true, detail:{variantId:option.value, imageIndex:imageIndex ?? null}}));
    });
  };

  const initialiseWithin = (container) => {
    if (container.matches?.('[data-oakverly-product]')) initialiseProduct(container);
    container.querySelectorAll('[data-oakverly-product]').forEach(initialiseProduct);
  };
  initialiseWithin(document);
  document.addEventListener('shopify:section:load', event => initialiseWithin(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
